module.exports = __webpack_public_path__ + "static/img/pd.84fd7d4.svg";